import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';

export default function setupAdmin() {
  extend(SessionDropdown.prototype, 'items', (items) => {
    const user = app.session.user;

    if (!user) {
      return;
    }

    const adminGroupId = app.forum.attribute('bbs-osa-mall.adminGroupId');
    const userGroups = user.groups();
    const isMallAdmin = adminGroupId && userGroups && userGroups.find((group) => group && group.id() === adminGroupId);

    if (!user.isAdmin() && !isMallAdmin) {
      return;
    }

    items.add(
      'osa-mall',
      Button.component(
        {
          icon: 'fa fa-store',
          onclick: () => {
            window.open('/mall-admin');
          },
        },
        '商城后台'
      ),
      -1
    );
  });
}
